import {React, useEffect} from "react";
import HeroHeader from "./HeroHeader";
import ContactCTA from "./ContactCTA";
import { Link } from "react-router-dom";


import Layout1 from "../img/cellscape.png";
import LabAnim from "../video/lab anim.mp4";
import RatWalk from "../video/rat_anim.mp4";
import Prosthesis1 from "../video/run_anim0001-0020.mp4";
import Prosthesis2 from "../video/prosthesis_turnaround.mp4";
import HeartArmature from "../img/heart_armature.gif";
import TEEintro from "../video/intro0110-1189.mp4";
import HeartRef from '../img/MRP/heart_reference.gif'
import Cellscape from "../video/cellscape_anim.mp4";
import Alveoli from "../video/alveoli_anim.mp4";
import Phage from '../video/phage_anim.mp4';
import AEE from '../video/AEE.mp4';



function MiscMedical() {

  useEffect(() => {
    document.title = "ETCHNG | Miscellaneous Medical 3D";  
  
  }, []);  
  return (
    <>
      <HeroHeader
        hero_img={Layout1}
        type="Animation —"
        name="Miscellaneous Medical 3D"
       
      />

      <div className="wrapper">
        <div className="wrapper__inner">
          <div className="work">
            <div className="work__info twoColumn">
              <div className="work__info__basic">
              <div className='work__info__basic__item'> <h5>Date</h5>
                  <p>2015 - current</p> </div>
                  <div className='work__info__basic__item'>    <h5>Role</h5>
                  <p>3D artist</p></div>
                  <div className='work__info__basic__item'> <h5>Tools</h5>
                  <p>Blender, Maya, ZBrush</p></div>
              </div>
            </div>

            <div className="work__info twoColumn">
              <h4>INTRODUCTION</h4>
              <p>
              These are various 3D animation clips from some projects I've worked on over the years. Some are just fun
              experiements, others are more narrative-driven visuals.              </p>

            
            </div>

            
          </div>
        

        <div className="work">

          <div className="work__info narrowColumn">
            <p>
              This was the opening sequence for an animation on optogenetics, showing (part of) how opsin is introduced
              into a plasmid, as well as the rat being controlled by an optrode.


            </p>

          </div>
          <div className="work__info wideColumn">

            <video loop controls  >
              <source src={LabAnim} loading="lazy" type="video/mp4"/>
              Your browser does not support the video tag.
            </video>
            <video loop controls  >
              <source src={RatWalk} loading="lazy" type="video/mp4"/>
              Your browser does not support the video tag.
            </video>





          </div>

        </div>




        <div className="work">

          <div className="work__info narrowColumn">
            <p>
             This biomechanically-accurate and real-time optimized heart model was built as part of a <Link to="/work/TEEsim">
              cardiac ultrasound simulator I had designed</Link>.
              
              </p>  <p>
              Drawing on my background in anatomy and cadaver dissection, and my role as the technical artist, the model needed to accurately
                  reflect proper contractile and pressure biomechanics, including the torsional motion of the
                  ventricles during systole, and overall synchornization. In particular, technical requirements involved needing the lumenal and tissue spaces to be fully
                  manifold and independent.


            </p>

            <img src={HeartArmature} loading="lazy"
            alt="Additional probe-heart interaction features."></img>

          </div>
          <div className="work__info wideColumn">

            <video loop controls  >
              <source src={TEEintro} loading="lazy" type="video/mp4"/>
              Your browser does not support the video tag.
            </video>
          
            <img src={HeartRef} loading="lazy"
            alt="Additional probe-heart interaction features."></img>

           


          </div>

        </div>

        
        <div className="work">

          <div className="work__info narrowColumn">
            <p>
              This was a visualization for a running prosthesis.

            </p>

          </div>
          <div className="work__info wideColumn">

            <video loop controls  >
              <source src={Prosthesis1} loading="lazy" type="video/mp4"/>
              Your browser does not support the video tag.
            </video>





          </div>

        </div>
        <div className="work">

          <div className="work__info narrowColumn">
            <p>

            </p>

          </div>
          <div className="work__info wideColumn">

            <video loop controls  >
              <source src={Prosthesis2} loading="lazy" type="video/mp4"/>
              Your browser does not support the video tag.
            </video>





          </div>

        </div>
        <div className="work">

          <div className="work__info narrowColumn">
            <p>
              These clips were created for workshop I led on using Blender new Geometry Nodes system in science
              visualization.

            </p>

          </div>
          <div className="work__info wideColumn">

            <video loop controls  >
              <source src={Cellscape} loading="lazy" type="video/mp4"/>
              Your browser does not support the video tag.
            </video>





          </div>

        </div>
        <div className="work">

          <div className="work__info narrowColumn">


          </div>
          <div className="work__info wideColumn">

            <video loop controls  >
              <source src={Alveoli} loading="lazy" type="video/mp4"/>
              Your browser does not support the video tag.
            </video>





          </div>

        </div>
        <div className="work">

          <div className="work__info narrowColumn">


          </div>
          <div className="work__info wideColumn">

            <video loop controls  >
              <source src={Phage} loading="lazy" type="video/mp4"/>
              Your browser does not support the video tag.
            </video>





          </div>

        </div>


        <div className="work">

          <div className="work__info narrowColumn">
            <p>
            This was a concept animation for explaining how Avoidable Experiment Expenditure is a bottleneck in drug development.


            </p>

          </div>
          <div className="work__info wideColumn">

            <video loop controls  >
              <source src={AEE} loading="lazy" type="video/mp4"/>
              Your browser does not support the video tag.
            </video>
      





          </div>

        </div>

           

        </div>

        <ContactCTA />
      </div>
    </>
  );
}

export default MiscMedical;
